import { createReducer } from "@reduxjs/toolkit";
import { updateOEQ, submitOEQ } from "./actions";

// Initial state
const initialState = {};

// Reducer
const OEQReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(updateOEQ, (state, action) => {
      const { componentID, text } = action.payload;
      // Immer allows direct mutation of the state
      if (!state[componentID]) {
        state[componentID] = {}; // Initialize if componentID doesn't exist
      }
      state[componentID].text = text;
      state[componentID].textChanged = true; // Reset complete status on update
    })
    .addCase(submitOEQ, (state, action) => {
      const componentID = action.payload;
      if (state[componentID]) {
        if (state[componentID].complete && state[componentID].textChanged) {
          state[componentID].resubmitted = true;
        }
        state[componentID].complete = true;
        state[componentID].textChanged = false;
      }
    });
});

export default OEQReducer;
